module.exports = __webpack_public_path__ + "img/8-5.f48d5191.png";